var map = {
	"./categorize.webp": 2782,
	"./fill-blank-selection.webp": 2783,
	"./fill-blank-typing.webp": 2784,
	"./flashcards.webp": 2785,
	"./multiple-choice.webp": 2786,
	"./order.webp": 2787,
	"./single-choice.webp": 2788,
	"./true-false.webp": 2789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3544;